import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JVInput } from "../../shared/JVInput";

export interface IFilter {
  consultant_Name: string | null;
  consultant_Email_ID: string | null;
}

interface IProps {
  filters: IFilter;
  setFilters: (filters: IFilter) => void;
}

export const EmptyFilter: IFilter = {
  consultant_Name: "",
  consultant_Email_ID: "",
};

const schema = yup.object({
  consultant_Name: yup.string().nullable(),
  consultant_Email_ID: yup.string().nullable(),
});

const Filter = (props: IProps) => {
  const { control, handleSubmit, reset } = useForm<IFilter>({
    resolver: yupResolver(schema),
    defaultValues: props.filters,
  });

  const onSubmit = (data: IFilter) => {
    props.setFilters({ consultant_Name: data.consultant_Name?.trim() || null, consultant_Email_ID: data.consultant_Email_ID?.trim() || null });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
      <JVInput column={6} label="Consultant Name" control={control} name="consultant_Name" />

      <JVInput column={6} label="Email" control={control} name="consultant_Email_ID" />

      <div className="col-12 flex gap-2 mt-2">
        <Button label="Search" type="submit" />

        <Button
          label="Clear"
          type="button"
          className="p-button-outlined"
          onClick={() => {
            reset(EmptyFilter);
            props.setFilters(EmptyFilter);
          }}
        />
      </div>
    </form>
  );
};

export default Filter;
